/* eslint-disable no-shadow */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Table, Button } from 'antd';
import { Permission } from 'components/page/index';
import PERMISSIONS from 'config/app-permission.config';
import Enums from 'utils/EnumsManager';
import { Panel } from 'components/ui/index';
import { intlShape, injectIntl } from 'react-intl';
import { PAGE_ACTION } from 'config/app.config';
import { setScopeValue } from '../../Users/flow/action';


const { ScopeTypes } = Enums;
const { All, Active, Inactive } = ScopeTypes;
class companyUserStatic extends React.Component {

  render() {
    const { userInfo, history, setScopeValue } = this.props;
    const { formatMessage } = this.props.intl;
    const rightActions = (() => {
      const actions = [];
      actions.push(<Permission
        permission={PERMISSIONS.SETUP_COMPANYPROFILE_USERS_ADD}
        key="addBtn"
      >
        <Button
          className="btn-ellipse ml-sm"
          size="small"
          icon="user-add"
          onClick={() => history.push(`/setup/company-info/users?action=${PAGE_ACTION.ADD}`)}
        >{ formatMessage({ id: 'page.comInfo.addNewUser' })}
        </Button>
      </Permission>);
      actions.push(<Permission
        permission={PERMISSIONS.SETUP_COMPANYPROFILE_USERS}
        key="viewAll"
      >
        <Button
          className="btn-ellipse ml-sm"
          size="small"
          icon="eye"
          onClick={() => history.push(`/setup/company-info/users?action=${PAGE_ACTION.VIEWALL}`)}
        >{ formatMessage({ id: 'global.ui.button.view' }, { actionType: formatMessage({ id: 'global.properNouns.users' }) })}
        </Button>
                   </Permission>);
      return actions;
    })();

    const handleClick = (key) => {
      history.push('/setup/company-info/users');
      setScopeValue(key);
    };

    const jumpToUsers = (text, key) => (
      <span
        className="cursor-pointer"
        onClick={() => {
          handleClick(key);
        }}
      >
        {text}
      </span>
    );

    const dataSource = [Object.assign({}, userInfo, { key: 1 })];
    const columns = [{
      title: formatMessage({ id: 'page.comInfo.totalUser' }),
      dataIndex: 'total',
      key: 'total',
      render: (text) => jumpToUsers(text, All)
    }, {
      title: formatMessage({ id: 'page.comInfo.activeUser' }),
      dataIndex: 'activeCount',
      key: 'activeCount',
      render: (text) => jumpToUsers(text, Active)
    }, {
      title: formatMessage({ id: 'page.comInfo.inactiveUser' }),
      dataIndex: 'inactiveCount',
      key: 'inactiveCount',
      render: (text) => jumpToUsers(text, Inactive)
    }];
    return (
      <Panel panelTitle={formatMessage({ id: 'global.properNouns.users' })} actionsRight={rightActions}>
        <Table dataSource={dataSource} columns={columns} pagination={false} />
      </Panel>
    );
  }
}
companyUserStatic.propTypes = {
  intl: intlShape.isRequired,
  userInfo: PropTypes.object,
  history: PropTypes.object,
  setScopeValue: PropTypes.func,
};

const mapDispatchToProps = {
  setScopeValue
};
export default connect(
  null,
  mapDispatchToProps,
)(injectIntl(companyUserStatic));



// WEBPACK FOOTER //
// ./src/views/Setup/CompanyInfo/component/companyUserStatic.jsx